import axios, { AxiosRequestConfig, Method } from 'axios';

import { resetAuthLocalStorage, verifyAccessToken } from './auth';
import history from '../history';

const callApi = async (
  url: string,
  method: Method,
  urlParams = {},
  data: any = null,
  headers: any = null,
) => {
  const combineURL = (url: string) => {
    const server_path = process.env.REACT_APP_SERVER_PATH || '';
    if (url.startsWith(server_path)) {
      return new URL(url).href;
    } else {
      return new URL(`${process.env.REACT_APP_SERVER_PATH}/${url}`).href;
    }
  };

  try {
    let response;
    let error;

    if (url.startsWith('/api')) {
      url = url.replace(/^\/api/, '');
    }
    if (url.startsWith('/')) {
      url = url.substring(1);
    }
    try {
      response = await axios.request(getRequest());
    } catch (err) {
      error = err;
      // if its unauthorized response, then retry after verification of access token
      if (error.response?.status === 401) {
        await verifyAccessToken();
        // retry and resend the request again
        try {
          error = null;
          response = await axios.request(getRequest());
        } catch (err) {
          error = err;
        }
      } else if (error.response?.status === 503) {
        handleMaintenanceMode();
        Promise.reject(error);
      }
    }

    // asyncApiLogger(Date.now(), request, response, error);

    if (error) {
      logError(combineURL(url), method, urlParams, data, headers, error);
      return Promise.reject(error?.response ? error.response : error);
    }

    return Promise.resolve(response);
  } catch (error) {
    logError(url, method, urlParams, data, headers, error);
    return Promise.reject(error);
  }

  function getRequest() {
    const authHeader = {
      Authorization: 'Bearer ' + localStorage.getItem('access'),
    };
    const request: AxiosRequestConfig = {
      url: combineURL(url),
      method,
      headers: {
        ...headers,
        ...authHeader,
      },
      params: urlParams,
      data,
    };
    return request;
  }
};

export function handleMaintenanceMode() {
  // Handle the maintenance mode response here
  resetAuthLocalStorage();
  localStorage.setItem('maintenanceEnabled', 'true');
  if (window.location.pathname !== '/maintenance') {
    history.push('/maintenance');
  }
}

function logError(
  url: string,
  method: Method,
  urlParams,
  data: any,
  headers: any,
  error: any,
) {
  console.log({
    message: 'An error occurred calling back-end API',
    url,
    method,
    urlParams,
    data,
    headers,
    error: {
      response: error.response,
      name: error.name,
      message: error.message,
      stack: error.stack,
    },
  });
}

export default callApi;
